module.exports = __webpack_public_path__ + "assets/5c5680144fc976246808f76a193db804.mp3";